export const PRINTFUL_CATEGORIES_FIELDS_LIST: any = [
    {attribute: "id", label: "ID", cssClass: ''},
    {attribute: "parent_id", label: "Parent Id", cssClass: ''},
    {attribute: "parent", label: "Parent", cssClass: ''},
    {attribute: "image_url", label: "Image", cssClass: '', type: 'image'},
    {attribute: "title", label: "Title", cssClass: ''},
    {attribute: "key", label: "Key", cssClass: ''},
    /*{attribute: "total", label: "Total", cssClass: ''},*/
    {attribute: "catalog_position", label: "Catalog Position", cssClass: ''},
];


export const PRINTFUL_CATEGORIES_INPUT_FIELDS: any = [
    {attribute: "id", label: "ID", type: 'text', group: 'detail', cssClass: ''},
    /*{attribute: "total", label: "Total", type: 'text', group: 'detail', cssClass: ''},*/
    {attribute: "catalog_position", label: "Catalog Position", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "parent_id", label: "Parent Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "title", label: "Title", type: 'text', group: 'detail', cssClass: ''},
];
